import React, {Component} from 'react';
import {connect} from "react-redux";
import {injectIntl} from "react-intl";
import DataPrivacyFr from "./DataPrivacyFr";
import DataPrivacyNl from "./DataPrivacyNl";
import {Card, Col, Row} from "antd";
import "./DataPrivacy.css"

class DataPrivacy extends Component {

  render() {
    return (
      <Row gutter={32} type={"flex"} className={"data-privacy"}>
        <Col>
          <Card>
            <DataPrivacyFr/>
            <DataPrivacyNl/>
          </Card>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(injectIntl(DataPrivacy));
